import { createRgFormAPI } from '~/api/core/rgRequest';

const canCustomizeLinkPostsAPI = createRgFormAPI('/can_customize_link_posts');
const setDnsVerificationAPI = createRgFormAPI('/set_dns_verification');

export const canCustomizeLinkPosts = async (url: string, pageId: string): Promise<boolean> => {
  try {
    const { data } = await canCustomizeLinkPostsAPI.post({ url, pageId });

    return data;
  } catch (e) {
    throw new Error(e);
  }
};

export const setSiteVerification = async (code: string) => {
  try {
    const { data } = await setDnsVerificationAPI.post({ code });

    return data;
  } catch (e) {
    throw new Error(e);
  }
};
